import {baseUrl, skdUrl} from '@/common/js/http/pdBase'
import * as _ from 'lodash'
import searchMap from '@/views/search/utils/searchMap'

const MixinsHandleGraph = {
  data () {
    return {
      graphLoading: false,
      id: 0,
      extraData: {},
      apiSearchNode: '/country/graphExplore',
      apiSearchId: '/country/getEntityId',
      apiAddNode: '',
      graphSettings: {
        fun: 'requestGraph',
        data: 'id'
      },
      graphJumpSearchUrl: '/searchType/All/1/'
    }
  },
  methods: {
    addNode (item) { // 双// 加探索的方法
      this.searchNode(item.id, true)
        .then((data) => {
          this.$refs.graph.addNode(item.id, data)
        })
    },
    // 搜索节点
    searchNode: function (id, isAdd = false) {
      this.graphLoading = true
      const data = _.merge(_.cloneDeep(this.extraData), {id: id || this.id})
      data.pageNum = (this.graphValue && this.graphValue.page) || 1
      data.pageSize = (this.graphValue && this.graphValue.size) || 10
      const url = isAdd && this.apiAddNode ? this.apiAddNode : this.apiSearchNode
      return this.$pdAxios({
        method: 'post',
        url,
        data,
        baseURL: skdUrl
      })
        .then((data) => {
          this.graphLoading = false
          if (data.data.errCode === 200) {
            return Promise.resolve(data.data.data)
          }
        }).catch(() => {
          this.graphLoading = false
        })
    },
    // 搜索实体的id
    searchId (text = this.filter && this.filter.searchmatter) {
      if (!text) {
        return Promise.reject(new Error())
      }
      const url = text ? this.apiSearchId + '/' + text : this.apiSearchId
      return this.$pdAxios({
        method: 'post',
        url,
        baseURL: baseUrl
      }).then((data) => {
        if (data.data.errCode === 200) {
          this.id = data.data.data
          return Promise.resolve(this.id)
        } else {
          return Promise.reject(data.data)
        }
      })
        .catch((error) => {
          this.$message.error(error.message)
          return Promise.reject(error)
        })
    },
    // 翻页处理
    changeGraphPage (type, val) {
      if (type === 'pageNum') {
        this.graphValue.page = val
      } else {
        this.graphValue.size = val
      }
      eval(`this.${this.graphSettings.fun}(${this[this.graphSettings.data]})`)
    },
    jumpSearch (pdNode) {
      const node = (pdNode.nodes && pdNode.nodes[0]) || pdNode.menu.selectNodes[0]
      if (node.name) {
        // 研报13
        if (node.classIdList.indexOf(4) !== -1) {
          const start = node.name.lastIndexOf('(')
          const end = node.name.lastIndexOf(')')
          if (start && end) {
            node.name = node.name.slice(0, start)
          }
          this.graphToSearchDetails(node.name)
        } else {
          // this.graphToSearchList({name: node.name})
          let url = this.$route.path + this.graphJumpSearchUrl + node.name
          this.$router.push({path: url})
        }
      } else {
        this.$message.error('请在节点上右击')
      }
    },
    graphToSearchDetails (name, type) {
      this.searchNodeToSearchList(name, type)
        .then((data) => {
          console.log(data)
          data && this.gotoSearchDetail(data)
        })
    },
    searchNodeToSearchList (name, type) {
      const data = {
        aggs: [],
        current: 0,
        docTypeList: ['All'],
        featureWeights: [],
        filters: [],
        hieghtQueryBean: [{column: '[\'title.keyword\']', type: 0, value: name, midd: 0}],
        isAggs: 1,
        isExplain: false,
        isFilter: 0,
        isRecovery: true,
        kw: '',
        pageNo: 1,
        pageSize: 1,
        psn: 10005,
        sortField: 'published',
        sorts: '1',
        templateId: '',
        token: ''
      }
      type && (data.highDz = true)
      return this.$pdAxios({
        method: 'post',
        url: '/search/simplekw',
        baseURL: baseUrl,
        data: data
      })
        .then((data) => {
          if (data.data.errCode === 200) {
            const rsData = data.data.data.rsData
            if (rsData && rsData.length) {
              return Promise.resolve(rsData[0])
            }
          }
        })
    },
    gotoSearchDetail (val, _firstPath = '') { // 进入详情
      if (val.sourceAsMap && ['data', 'space', 'live', 'special', 'project'].indexOf(val.sourceAsMap.modelType) !== -1) {
        window.location.href = val.sourceAsMap.url
        return
      }
      let id = _.split(val.sourceAsMap.contentid, '_')[1]
      const kgId = encodeURIComponent(val.sourceAsMap.title) || ''
      const typeItem = _.find(searchMap.typeAgg, ['value', val.sourceAsMap.column])
      if (val.sourceAsMap.modelType && val.sourceAsMap.modelType === 'type') {
        val.sourceAsMap.modelType = 'magazine'
      }
      let type = (val.sourceAsMap && val.sourceAsMap.modelType) || (typeItem && typeItem.id) || val.type
      let secondPath = ''
      if (!val.sourceAsMap.contentid) { // 研报
        id = val.sourceAsMap.eid
        type = '研报'
        secondPath = '/' + val.sourceAsMap.type
      }
      let firstPath = (_firstPath || this.$route.path) + '/searchDetail/' + id + '/' + type + '/' + kgId
      if (!this.$route.params.keyword && !_.endsWith(this.$route.path, '/') && !_firstPath) {
        firstPath = this.$route.path + '//searchDetail/' + id + '/' + type + '/' + kgId
      }
      let query = ''
      if (val.sourceAsMap) {
        // 配置kw传参
        const kw = (val.sourceAsMap.tags && val.sourceAsMap.tags.length && val.sourceAsMap.tags) || val.sourceAsMap['key_words']
        if (kw) {
          query = `${query}kw=${kw.toString()}`
        }
        if (val.sourceAsMap['one_level_state']) {
          query = `${query}&country=${val.sourceAsMap['one_level_state'].toString()}`
        }
      }
      const path = firstPath + secondPath + '?' + query
      this.$router.push({path})
    }
  }
}

export default MixinsHandleGraph
